<template>
  <div class="stories-menu">
    <div class="container-fluid p-0 m-0">
      <div class="stories-menu__content">
        <StoriesMenuSlider @selectedStory="openStory" :stories="stories"/>
      </div>
    </div>
  </div>
</template>

<script>
import StoriesMenuSlider from '../Menu/StoriesMenuSlider.vue';

export default {
  components: {StoriesMenuSlider},
  props: {
    stories: {}
  },
  methods: {
    openStory(data) {
      this.$emit('selectedStory', data)
    }
  }
}

</script>

<style lang="scss" scoped>

.stories-menu {
  overflow: hidden;
}
</style>